"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.SESSION_STOP_EVENT = exports.SESSION_START_EVENT = void 0;
// Standard session start & stop event names
exports.SESSION_START_EVENT = '_session.start';
exports.SESSION_STOP_EVENT = '_session.stop';
